import type React from 'react';
import { memo } from 'react';
import type { PlayerProps } from '@shared/ui/iframes/common-player/ui';
import { SCard } from '@shared/ui/iframes/PlayerInCard/styles';
import { AspectRatioContent, Player } from '@shared/ui/index';
import type { AspectRatioContentProps } from '@shared/ui/layout/aspect-ratio-content/ui';

type PT = React.HTMLAttributes<HTMLDivElement> &
  AspectRatioContentProps &
  PlayerProps & {
    aspectRationContentClassName?: string;
    playerClassName?: string;
  };
export const PlayerInCard = memo(
  ({ video, aspectRationContentClassName, playerClassName, children, ...props }: PT) => {
    return (
      <SCard {...props}>
        <AspectRatioContent className={aspectRationContentClassName}>
          <Player className={playerClassName} video={video} />
        </AspectRatioContent>

        {children}
      </SCard>
    );
  }
);
